import { ComboBox } from "@carbon/react";
import { useQuery, gql } from "@apollo/client";
import React, { useEffect, useMemo } from "react";

// normalize for searching (handles umlauts/accents, case-insensitive)
const norm = (s) => {
  if (s == null) return '';
  return s
    .toString()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase();
};

const ALL_TEACHERS_QUERY = gql`
    query AllTeachers {
        allTeachers {
            id
            username
            surname
            lastname
            classes {
                id
                name
            }
        }
    }
`;

export default function TeacherSelector({ selectedTeacher = null, onTeacherChange, enableAllTeachers = false }) {
    const { data, loading, error } = useQuery(ALL_TEACHERS_QUERY, {
        fetchPolicy: "no-cache", // Disable caching
    });

    const items = useMemo(() => {
        if (!data || !data.allTeachers) return [];
        const teacherItems = data.allTeachers.map((teacher) => ({
            id: teacher.id,
            text: `${teacher.lastname ? teacher.lastname.toUpperCase() : ''} ${teacher.surname ? teacher.surname : ''}${teacher.username ? ` (${teacher.username})` : ''}`.trim(),
        }));
        if (enableAllTeachers) {
            teacherItems.unshift({ id: '*', text: 'Alle Lehrer' });
        }
        return teacherItems;
    }, [data, enableAllTeachers]);

    const selectedItem = useMemo(() => items.find((item) => item.id === selectedTeacher) || null, [items, selectedTeacher]);

    useEffect(() => {
        if (data && data.allTeachers.length > 0 && !selectedTeacher) {
            // If no teacher is selected, set the first teacher as default
            onTeacherChange && onTeacherChange(data.allTeachers[0].id);
        }
    }, [data, selectedTeacher, onTeacherChange]);

    if (loading) return <p>Lehrer werden geladen…</p>;
    if (error) return <div>Fehler beim Laden der Lehrer: {error.message}</div>;

    return (
        <ComboBox
            id="teacher-select"
            titleText="Lehrer auswählen"
            placeholder="Suchen…"
            items={items}
            selectedItem={selectedItem}
            onChange={({ selectedItem }) => onTeacherChange && onTeacherChange(selectedItem ? selectedItem.id : null)}
            itemToString={(item) => (item ? item.text : '')}
            shouldFilterItem={({ item, itemToString, inputValue }) => {
                const hay = norm(itemToString(item));
                const needle = norm(inputValue);
                return hay.includes(needle);
            }}
        />
    );
}